// import { Component, OnInit, Input, Optional, Host, SkipSelf, forwardRef } from '@angular/core';
// import { DropdownFormControl } from '../dropdown-form-control';
// import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
// import { TranslateService } from '@ngx-translate/core';
// import { MasterService } from 'src/app/services/master.service';
// import { inputMgsErrs } from 'src/app/validators/message-validation';
// import { Log } from 'src/app/core/console.log';
// import { DropdownModel } from 'src/app/models/master/dropdown-model';

import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Log } from 'src/app/core/console.log';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { PlanGroupRiderModel } from 'src/app/models/select-plans/product-rider.model';
import { MasterService } from 'src/app/services/master.service';
import { DropdownFormControl } from 'src/app/shared/inputs/dropdown-form-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-dp-riders-fixed',
  templateUrl: './input-dp-riders-fixed.component.html',
  styleUrls: ['./input-dp-riders-fixed.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpRidersFixedComponent),
      multi: true
    }
  ]
})
export class InputDpRidersFixedComponent extends DropdownFormControl implements OnInit {
  @Input() valRider: any;
  errors = inputMgsErrs.titleName;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  initDropdownList() {
    this.resetDropdownList();
    let val = [];
    this.valRider.forEach(item => {
      val.push(
        {
          data :
          {
            code: item.productCode,
            desc: null,
            desc2: null,
            id: item.productId,
            name: item.productCode,
          },
          label : item.productCode,
          value : item.productCode,
        }
      )
    });
    this.items.push(...val);
    this.findValueFromList(this.value);
    this.setAfterLoadItemDropdown();
  }

  choiceDropdownList(tab: PlanGroupRiderModel) {
    this.resetDropdownList();
    let val = [];
    tab.product.forEach(item => {
      val.push(
        {
          data :
          {
            code: item.productCode,
            desc: null,
            desc2: null,
            id: item.productId,
            name: item.productCode,
          },
          label : item.productCode,
          value : item.productCode,
        }
      )
    });
    this.items.push(...val);
    this.findValueFromList(this.value);
    this.setAfterLoadItemDropdown();
  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
    // this.translate.get('input.dropdown.select.province').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }

}
